import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import ButtonEdit from '../../../components/Editor/ButtonEdit';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			activeItem,
			isPageBackgroundActive,
		},
	} = state;

	return {
		isDisabled: !activeItem.id && !isPageBackgroundActive,
	};
};

export default connect(mapStateToProps)(ButtonEdit);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ButtonEdit/index.tsx